import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { LoadingService } from "src/app/ui/services/loading.service";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { BeneficiaryService } from "src/app/ui/services/pbm/beneficiary.service";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { FormDirty } from "src/app/ui/models/utils/form-dirty.utils";
import { Gender, MaritalStatus } from "src/app/ui/models/domains/pbm/Beneficiary/person";
import { SaveBeneficiaryValidator } from "../validators/save-beneficiary-validator";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { Address } from "src/app/ui/models/domains/pbm/companies/address";
import { BeneficiaryKey } from "src/app/ui/models/domains/pbm/Benefit/beneficiary-key";
import { GenderType } from "src/app/ui/models/domains/pbm/Beneficiary/gender-type";
import { Toast } from "../../../toast/toast";
import { Employee } from "src/app/ui/models/domains/pbm/Beneficiary/employee";
import { Card } from "src/app/ui/models/domains/pbm/Beneficiary/card";
import { StateAcronym } from "src/app/ui/models/domains/pbm/state/state-acronym";
import { StateService } from "src/app/ui/services/pbm/state.service";
import { City } from "src/app/ui/models/domains/pbm/state/city";
import { UserService } from "src/app/ui/services/user.service";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { Router } from "@angular/router";
import { CardBlockDialogComponent } from "../dialogs/card-block-dialog/card-block-dialog.component";
import { JobDescription } from "src/app/ui/models/domains/pbm/Beneficiary/job-description";
import { AddJobDescriptionDialog } from "../../shared/dialogs/add-job-description-dialog/add-job-description-dialog.component";
import { JobDescriptionService } from "src/app/ui/services/pbm/job-description.service";
import { JobDescriptionDialogType } from "../../shared/dialogs/add-job-description-dialog/add-job-description-dialog.enum";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { AppContext } from "src/app/ui/contexts/app-context";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { UntypedFormControl } from "@angular/forms";
import { ICompanyFilterParams } from "src/app/ui/models/domains/pbm/companies/company-filter-params";
import { CustomValidators } from "src/app/ui/models/domains/pbm/custom-validators";
import { VinculatedSocialnumberDialogComponent } from "./vinculated-socialnumber/vinculated-socialnumber-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatSlideToggle } from "@angular/material/slide-toggle";

@Component({
  selector: "app-registration-beneficiary",
  templateUrl: "./registration-beneficiary.component.html",
  styleUrls: ["./registration-beneficiary.component.scss"],
})
export class RegistrationBeneficiaryComponent implements OnInit {
  public region: string = "";
  public city: string = "";
  public filterText: string;
  private company: Company;
  private beneficiary: Beneficiary;
  private selectedTabIndex = 0;
  private formDirty = new FormDirty();
  private jobDescriptionList: JobDescription[] = [];
  private stateList: StateAcronym[] = [];
  private cityList: City[] = [];
  private cardBlockDialogRef: MatDialogRef<CardBlockDialogComponent>;
  private addJobDescriptionRef: MatDialogRef<AddJobDescriptionDialog>;
  public companyPageableResult = new PageableResult();
  private searchCompanyFirst: boolean;
  private userProfile = this.userService.getUserProfile();

  public fiscalNumberMask = MaskInput.getFicalNumberMask();
  public socialNumberMask = MaskInput.getSocialNumberMask();
  public dateMask = MaskInput.getDateMask();
  public zipCodeMask = MaskInput.getZipCodeMask();
  public telephoneMask = MaskInput.getTelephoneMask();
  public mobileMask = MaskInput.getMobileMask();

  public genderType = GenderType;
  public searchType: UntypedFormControl;

  public userNameInputBorder = "1px white solid";
  public beneficiaryInfo = null;
  public socialNumberFind = '';

  public alertLogin = false;
  public userErrorVisible = false;

  public registrationBeneficiaryForm: UntypedFormGroup = this.formBuilder.group({
    beneficiaryKey: [""],
    active: [true],
    cardNumber: [""],
    name: ["", Validators.required],
    registration: [""],
    jobDescription: [""],
    admissionDate: [""],
    socialNumber: ["", Validators.required],
    birthDate: [""],
    gender: [0, Validators.required],
    maritalStatus: [0, Validators.required],
    isNewAddress: [false],
    street: [""],
    number: [""],
    complement: [""],
    district: ["", Validators.required],
    city: new UntypedFormControl({ value: this.city }, Validators.required),
    region: new UntypedFormControl({ value: this.region }, Validators.required),
    zipCode: [""],
    email: ["", Validators.required],
    telephone: [""],
    mobile: [""],
    needValidateEmail: [false],
    enableDelivery: [false],
    transactionPasswordRequired: [false],
  });

  constructor(
    private featureViewService: FeatureViewService,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private loadingService: LoadingService,
    private companyService: CompanyService,
    private beneficiaryService: BeneficiaryService,
    private jobDescriptionService: JobDescriptionService,
    private toast: Toast,
    private stateService: StateService,
    private userService: UserService,
    private router: Router,
    private appContext: AppContext,
  ) {
    this.searchType = new UntypedFormControl(1);
  }

  async ngOnInit() {
    this.userProfile = this.userService.getUserProfile();
    this.featureViewService.activeFeatureView(FeatureViews.BeneficiaryRegistrationBeneficiaryFeatureView, PageViews.BeneficiaryPageView);

    if (this.userProfile.getPreferences().getFilterText()) {
      this.searchCompanies(this.userProfile.getPreferences().getFilterText());
    } else {
      this.searchCompanies("");
    }
    this.stateList = await this.stateService.getStates();
  }

  private getTabIndex(tabName: string): number {
    switch (tabName) {
      case "Cadastrar Beneficiário":
        return 0;
      case "Lista de Dependentes":
        return 1;
      default:
        return -1;
    }
  }

  onTabClick(clickEvent: any) {
    const clickedTab = clickEvent.target as HTMLDivElement;
    const clickedTabIndex = this.getTabIndex(clickedTab.innerText);
    if (clickedTabIndex === -1) {
      return;
    }
    if (this.selectedTabIndex !== clickedTabIndex) {
      if (this.formDirty.isDirty()) {
        alert("Os dados foram alterados no formulário. Por favor, salve antes de prosseguir.");
      } else {
        this.selectedTabIndex = clickedTabIndex;
      }
    }
  }
  public async getZipCode() {
    const formValue = this.registrationBeneficiaryForm.get("zipCode").value;
    var boolean = /^\d{5}[-]\d{3}$/.test(formValue);

    if (boolean) {
      const ref = this.loadingService.beginLoading();
      this.registrationBeneficiaryForm.get("zipCode").disable();
      try {
        const zip = await this.stateService.getZipCodeIntegration(formValue);
        const state = this.stateList.find((state) => state.getValue() === zip.getStateCode());
        this.registrationBeneficiaryForm.get("region").setValue(state);
        await this.onStateInputChange();

        const city = this.cityList.find((city) => city.getName() === zip.getLocality());
        this.registrationBeneficiaryForm.get("city").setValue(city);

        this.registrationBeneficiaryForm.get("street").setValue(zip.getAddress());
        this.registrationBeneficiaryForm.get("district").setValue(zip.getNeighborhood());
      } catch (error) {
        this.toast.showWarningToast("CEP não encontrado.");
      } finally {
        this.loadingService.finishLoading(ref);
        this.registrationBeneficiaryForm.get("zipCode").enable();
      }
    }
  }

  async searchCompany(company: Company) {
    const ref = this.loadingService.beginLoading();
    try {
      if (!!company.getFiscalNumber()) {
        this.company = await this.companyService.findCompanyBy(company.getFiscalNumber());
        this.jobDescriptionList = await this.jobDescriptionService.getJobDescription(this.company.getFiscalNumber());
        if (!!this.company) {
          this.storageSearchPreferences(company.getFiscalNumber());
        } else {
          this.storageSearchPreferences(null);
        }
      } else {
        this.toast.showWarningToast("Insira um CNPJ.");
      }
    } catch (erro) {
      this.toast.showWarningToast(erro);
      this.storageSearchPreferences(null);
    } finally {
      this.loadingService.finishLoading(ref);
      //this.storageSearchPreferences(company.getFiscalNumber());
      this.filterText = "";
    }
  }

  async searchBeneficiary() {
    const socialNumber = this.registrationBeneficiaryForm.get("socialNumber").value.replace(/[^\d]+/g, "");
    if (socialNumber.length === 11 && this.socialNumberFind !== socialNumber && !this.beneficiaryInfo) {
      this.socialNumberFind = socialNumber;
      this.beneficiaryInfo = await this.searchBeneficiaryBySocialNumber(socialNumber, this.company.getFiscalNumber());
      if (this.beneficiaryInfo) {
        let message = this.beneficiaryInfo.getCompany().length === 1 ? `Beneficiário já está cadastrado no portal junto à empresa ${this.beneficiaryInfo.getCompany()[0].getCorporateName()}.` : `Beneficiário já está cadastrado no portal em ${this.beneficiaryInfo.getCompany().length} empresas.`;
        message += "\r\n Para ver mais detalhes clique no ícone de informação (¡) ao lado do campo CPF.";
        this.toast.showWarningToast(message, "CPF já vinculado");
      }
    } else {
      this.beneficiaryInfo = null;
    }
  }

  private async searchBeneficiaryBySocialNumber(socialNumber: string, fiscalNumber:string) {
    const ref = this.loadingService.beginLoading();
    try {
      return await this.beneficiaryService.findBeneficiaryHolderBySocialNumber(socialNumber, fiscalNumber);
    } catch (erro) {
      console.error(erro);
      this.toast.showWarningToast(`Beneficiário ainda não está cadastrado no portal.`, "CPF não vinculado");
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  openVinculatedDialog() {
    const socialNumber = this.registrationBeneficiaryForm.get("socialNumber").value.replace(/[^\d]+/g, "");
    if (socialNumber.length === 11 && this.socialNumberFind === socialNumber) {
      this.dialog.open(VinculatedSocialnumberDialogComponent, {
        id: "status-dialog",
        disableClose: true,
        hasBackdrop: true,
        width: "400px",
        data: { beneficiary: this.beneficiaryInfo },
      });
    }
  }

  hasCompany(): boolean {
    return !!this.company;
  }

  hasBenficiary(): boolean {
    return !!this.beneficiary;
  }

  onBeneficiaryInputChange(): void {
    this.formDirty.markAsDirty();
  }

  async onStateInputChange() {
    const state = this.registrationBeneficiaryForm.get("region").value;
    if (state) {
      const ref = this.loadingService.beginLoading();
      try {
        this.cityList = await this.stateService.getCityByStateAcronym(state);
        this.registrationBeneficiaryForm.get("city").enable();
        this.registrationBeneficiaryForm.get("city").setValue(0);
      } catch (error) {
        this.cityList = [];
        this.registrationBeneficiaryForm.get("city").disable();
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.cityList = [];
      this.registrationBeneficiaryForm.get("city").setValue(0);
      this.registrationBeneficiaryForm.get("city").disable();
    }
  }

  gotToCreateDependent(): void {
    const newDependent = new Dependent();
    newDependent.setBeneficiarySocialNumber(this.beneficiary.getSocialNumber());
    this.beneficiaryService.setDependent(newDependent);
    this.router.navigate([RoutePath.RegistrationDependent]);
  }

  goToEditDependent(dependent: Dependent): void {
    this.beneficiaryService.setDependent(dependent);
    this.router.navigate([RoutePath.EditDependent]);
  }

  async saveBenficiary(): Promise<any> {
    const ref = this.loadingService.beginLoading();
    const saveBeneficiaryValidator = new SaveBeneficiaryValidator(this.registrationBeneficiaryForm);
    if (saveBeneficiaryValidator.validate().hasErrorMessages()) {
      this.toast.showWarningToast(saveBeneficiaryValidator.getValidationResult().getErrorMessage());
      this.loadingService.finishLoading(ref);
    } else {
      const newBeneficiaryConfiguration = new Beneficiary();
      if (this.hasBeneficiaryKey()) {
        newBeneficiaryConfiguration.setBeneficiaryKey(this.beneficiary.getBeneficiaryKey());
        newBeneficiaryConfiguration.setCard(this.beneficiary.getCard());
      } else {
        const newBeneficiaryKey = new BeneficiaryKey();
        newBeneficiaryKey.setValue("");
        newBeneficiaryConfiguration.setBeneficiaryKey(newBeneficiaryKey);
        const card = new Card();
        card.setCardNumber("");
        newBeneficiaryConfiguration.setCard(card);
      }

      const employee = new Employee();
      employee.setRegistration(this.registrationBeneficiaryForm.get("registration").value);
      employee.setAdmissionDate(this.registrationBeneficiaryForm.get("admissionDate").value.replace(/[^\d]+/g, ""));
      employee.setJobDescription(this.registrationBeneficiaryForm.get("jobDescription").value);
      newBeneficiaryConfiguration.setEmployee(employee);

      newBeneficiaryConfiguration.setName(this.registrationBeneficiaryForm.get("name").value);
      newBeneficiaryConfiguration.setSocialNumber(this.registrationBeneficiaryForm.get("socialNumber").value.replace(/[^\d]+/g, ""));
      newBeneficiaryConfiguration.setBirthDate(this.registrationBeneficiaryForm.get("birthDate").value.replace(/[^\d]+/g, ""));
      newBeneficiaryConfiguration.setEmail(this.registrationBeneficiaryForm.get("email").value);
      newBeneficiaryConfiguration.setTelephone(this.registrationBeneficiaryForm.get("telephone").value.replace(/[^\d]+/g, ""));
      newBeneficiaryConfiguration.setMobile(this.registrationBeneficiaryForm.get("mobile").value.replace(/[^\d]+/g, ""));
      newBeneficiaryConfiguration.setNeedValidateEmail(this.registrationBeneficiaryForm.get("needValidateEmail").value);
      newBeneficiaryConfiguration.setEnableDelivery(this.registrationBeneficiaryForm.get("enableDelivery").value);
      newBeneficiaryConfiguration.setTransactionPasswordRequired(this.registrationBeneficiaryForm.get("transactionPasswordRequired").value);
      const personGender = new Gender();
      personGender.setGender(this.registrationBeneficiaryForm.get("gender").value);
      newBeneficiaryConfiguration.setGender(personGender);

      const personMaritalStatus = new MaritalStatus();
      personMaritalStatus.setMaritalStatus(this.registrationBeneficiaryForm.get("maritalStatus").value);
      newBeneficiaryConfiguration.setMaritalStatus(personMaritalStatus);

      const address = new Address();
      address.setStreet(this.registrationBeneficiaryForm.get("street").value);
      address.setNumber(this.registrationBeneficiaryForm.get("number").value);
      address.setComplement(this.registrationBeneficiaryForm.get("complement").value);
      address.setZipCode(this.registrationBeneficiaryForm.get("zipCode").value.replace(/[^\d]+/g, ""));
      address.setDistrict(this.registrationBeneficiaryForm.get("district").value);
      address.setCity(this.registrationBeneficiaryForm.get("city").value.getName());
      address.setRegion(this.registrationBeneficiaryForm.get("region").value.getValue());
      newBeneficiaryConfiguration.setAddress(address);

      try {
        if (newBeneficiaryConfiguration.getBeneficiaryKey().getValue() !== "") {
          const beneficiaryKey = await this.beneficiaryService.saveBeneficiary(this.company.getFiscalNumber(), newBeneficiaryConfiguration);
          this.beneficiary = await this.beneficiaryService.findBeneficiaryByKey(beneficiaryKey);
          this.beneficiaryService.setBeneficiary(this.beneficiary);
        } else {
          const beneficiaryKey = await this.beneficiaryService.saveBeneficiary(this.company.getFiscalNumber(), newBeneficiaryConfiguration);
          this.beneficiary = await this.beneficiaryService.findBeneficiaryByKey(beneficiaryKey);
          this.beneficiaryService.setBeneficiary(this.beneficiary);
          setTimeout(() => (this.selectedTabIndex = 1), 1500);
        }
        this.toast.showSuccessToast("Registro de beneficiário realizado com sucesso!");
        this.router.navigate([RoutePath.EditBeneficiary, this.beneficiary.getBeneficiaryKey().getValue()]);
      } catch (erro) {
        this.toast.showWarningToast(erro);
      } finally {
        this.formDirty.markAsClean();
        this.loadingService.finishLoading(ref);
      }
    }
  }

  onPressEnterSearchCompanies(event): void {
    if (event.key === "Enter") this.searchCompanies(this.filterText);
  }

  searchCompanies(filterText: string) {
    const start = 1;
    const end = this.appContext.getTotalPerPage();
    this.searchCompanyFirst = true;
    this.doSearchCompany(start, end, filterText);
  }

  searchMoreCompanies() {
    this.searchCompanyFirst = false;
    const start = this.companyPageableResult.getEnd() + 1;
    const end = this.appContext.getTotalPerPage();
    this.doSearchCompany(start, end, this.userProfile.getPreferences().getFilterText());
  }

  private doSearchCompany(start: number, end: number, filterText: string): void {
    const ref = this.loadingService.beginLoading();
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(start);
    pagingRequest.setEnd(end);

    const filterParams: ICompanyFilterParams = {
      filterText: filterText ? filterText.replace(/[./-]/g, "") : "",
    };
    this.companyService
      .searchCompany(filterParams, pagingRequest)
      .then((companyPageableResult) => {
        this.companyPageableResult.setStart(start);
        this.companyPageableResult.setEnd(end);
        this.companyPageableResult.setTotalItems(companyPageableResult.getTotalItems());

        if (this.searchCompanyFirst) {
          this.companyPageableResult.setItems(companyPageableResult.getItems());
        } else {
          this.companyPageableResult.addItems(companyPageableResult.getItems());
        }

        if (companyPageableResult.getItems().length === 1) {
          this.company = companyPageableResult.getItems().find((x) => x !== undefined) as Company;
          this.searchCompany(this.company);
          this.storageSearchPreferences(filterText);
        } else {
          this.company = null;
          this.storageSearchPreferences(null);
        }
      })
      .catch((error) => {
        this.companyPageableResult.setItems(null);
        this.storageSearchPreferences(null);
      })
      .finally(() => {
        this.loadingService.finishLoading(ref);
        this.filterText = "";
      });
  }

  showScrollBottomBtn(): boolean {
    return this.companyPageableResult.getItems().length > 1;
  }

  showMoreCompaniesBtn(): boolean {
    return this.companyPageableResult.getTotalItems() !== this.companyPageableResult.getItems().length && this.companyPageableResult.getItems().length > 1;
  }

  hasBeneficiaryKey(): boolean {
    return !!this.beneficiary && !!this.beneficiary.getBeneficiaryKey();
  }

  getDependents(): Dependent[] {
    return this.beneficiary.getDependets();
  }

  cardNumber(): string {
    return this.beneficiary.getCard().getCardNumber();
  }

  getCompany(): Company {
    return this.company;
  }

  getJobList(): JobDescription[] {
    return this.jobDescriptionList.filter((job) => job.getEnabled());
  }

  getStateList(): StateAcronym[] {
    return this.stateList;
  }

  getCityList(): City[] {
    return this.cityList;
  }

  getSelectedTabIndex(): number {
    return this.selectedTabIndex;
  }

  storageSearchPreferences(fiscalNumber: string): void {
    this.userService.setUserPreferences(fiscalNumber ? fiscalNumber.replace(/[./-]/g, "") : fiscalNumber);
  }

  openCardBlockDialog(): void {
    this.cardBlockDialogRef = this.dialog.open(CardBlockDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: "345px",
      width: "600px",
      data: this.beneficiary,
    });

    this.cardBlockDialogRef.componentInstance.blockCardNumberEvent.subscribe(async (data) => {
      this.router.navigate([RoutePath.EditBeneficiary, this.beneficiary.getBeneficiaryKey().getValue()]);
    });
  }

  isBeneficiaryCardBlocked(): boolean {
    return this.beneficiary.getCard() && this.beneficiary.getCard().getIsBlocked();
  }

  openAddJobDescriptionDialog() {
    this.addJobDescriptionRef = this.dialog.open(AddJobDescriptionDialog, {
      disableClose: true,
      hasBackdrop: true,
      height: "600px",
      width: "900px",
      data: {
        strategy: JobDescriptionDialogType.Beneficiary,
        company: this.company,
        jobDescriptionList: this.jobDescriptionList,
      },
    });

    this.addJobDescriptionRef.componentInstance.closeDialogEvent.subscribe(async (beneficiaryJobDescription: JobDescription) => {
      const loadingRef = this.loadingService.beginLoading();
      try {
        this.jobDescriptionList = await this.jobDescriptionService.getJobDescription(this.company.getFiscalNumber());
        if (beneficiaryJobDescription) {
          const peteca = this.jobDescriptionList.find((job) => job.getKey() === beneficiaryJobDescription.getKey());
          this.registrationBeneficiaryForm.get("jobDescription").setValue(peteca);
        }
      } finally {
        loadingRef.closeLoading();
      }
    });
  }

  scrollToLastCompany() {
    const bottom = document.getElementById("bottom");
    bottom.scrollIntoView();
  }
}
